var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.4062414,19.5402104 C13.1960819,22.9255662 13.1997577,28.3601708 16.4062414,31.7482053 L29.4994259,45.5854024 C29.6280123,45.7223879 29.8068819,45.8 29.9940009,45.8 C30.1811199,45.8 30.3599895,45.7223879 30.4885759,45.5854024 C34.8571458,40.9783653 39.2237763,36.3660806 43.5923803,31.7589407 C46.8025399,28.3735266 46.8025399,22.9363393 43.5923803,19.5509286 C40.3822547,16.1655214 35.1346401,16.1654459 31.9244805,19.5509286 L29.9993105,21.576666 L28.0741745,19.5402104 C26.4690777,17.8475051 24.3480994,17 22.2348813,17 C20.1216633,17 18.0113042,17.8475017 16.4062414,19.5402104 Z M27.5314157,22.0460801 L29.5908155,24.2306802 C29.7000142,24.3475123 29.8519198,24.4137068 30.0108319,24.4137068 C30.169744,24.4137068 30.3216497,24.3475123 30.4308483,24.2306802 L32.6691253,21.5884312 C35.6237865,18.798331 39.7021144,19.3664074 42,21.8 C44.2978567,24.2335896 43.0076399,28.4240096 40.7097832,30.8576022 C37.1410817,34.6370663 33.574981,38.4216785 30.0063085,42.2010841 L19.3028633,30.8484762 C17.0066831,28.4120172 16.4,24.2 18,21.8 C18.6096685,20.8854973 22.8,17 27.5314157,22.0460801 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLikeProfile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C13.4980195,0 0,13.4980195 0,30 C0,46.5019805 13.4980195,60 30,60 C46.5019805,60 60,46.5019805 60,30 C60,13.4980195 46.5019805,0 30,0 Z",
    id: "Stroke-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Heart",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeProfile);
export default __webpack_public_path__ + "static/media/icLikeProfile.78529eae353771dc6cb9786b3eaff575.svg";
export { ForwardRef as ReactComponent };